import withValidations from '../../common/withValidations';
import styledFrame from './Requester.frame';

const validations = {
  requesterFirstName: value => {
    if (!value) {
      return 'Requester must have a first name';
    }
    if (value?.length > 255) {
      return 'Cannot exceed 255 characters';
    }
    return null;
  },
  requesterLastName: value => {
    if (!value) {
      return 'Requester must have a last name';
    }
    if (value?.length > 255) {
      return 'Cannot exceed 255 characters';
    }
    return null;
  },
  requesterPhone: value => {
    if (!value) {
      return 'Requester must have a phone number';
    }
    if (value?.length < 14) {
      return 'Requester phone number must have all digits';
    }
    return null;
  },
  requesterExtension: value => {
    if (value?.length > 10) {
      return 'Cannot exceed 10 characters';
    }
    return null;
  },
};
export default withValidations(validations)(styledFrame);
